import {useI18nContext} from '../../i18n/i18n-react';
import formatDate from '../../utils/formatDate';
import {Icon, Icons} from '@toppy-webshop/toppy-design-system';

interface ShipmentStateProps {
    deliveryDate: Date | string | null;
}

const ShipmentState = ({deliveryDate}: ShipmentStateProps) => {
    const {LL} = useI18nContext();
    const today = new Date(new Date().setUTCHours(0, 0, 0));
    const deliveryDateObject = deliveryDate
        ? new Date(new Date(deliveryDate).setUTCHours(0, 0, 0))
        : new Date(new Date().setUTCHours(0, 0, 0));

    const dateFormatted = formatDate(deliveryDateObject);

    if (deliveryDate && deliveryDateObject >= today) {
        return (
            <>
                <span>
                    <i className="icon icon-car-speed" />
                    <strong>
                        {LL.shipment.state.expected.title()}: {dateFormatted}
                    </strong>
                </span>
            </>
        );
    }

    return (
        <>
            <span>
                <Icon icon={Icons.CHECKLIST} />
                <strong>{LL.shipment.state.inProgress.title()}</strong>
            </span>
        </>
    );
};

export default ShipmentState;
